import Thumbnail from 'Components/Thumbnail';
import moment from 'moment';
import { Box, Button, Card, CardActions, CardContent, CardHeader, Typography } from '@mui/material';
import { AssessmentItem } from './AssessmentsPage';
import { Link } from "@mui/icons-material";

interface Props {
	assessmentItem: AssessmentItem
	onSelect?: () => void
	selectText?: string
}

const AssessmentItemCard = (props: Props) => {
	const file = props.assessmentItem.assessment;

	const handleSelect = () => {
		props.onSelect && props.onSelect();
	};

	const info = props.assessmentItem.type === "DekraAssessment" ? "Ohne Auftrag" : "Beauftragt";
	const dateCreated = moment(props.assessmentItem.dateCreated).format("L");

	const selectText = props.selectText ?? (props.assessmentItem.type === "DekraAssessment" ? "Übernehmen" : "Anzeigen");

	return (
		<Card>
			<CardHeader
				title={
					<Box display="flex" justifyContent="space-between">
						<Box>{moment(props.assessmentItem.date).format("L")}</Box>
						{props.assessmentItem.isLinked && (
							<Box><Link /></Box>
						)}
					</Box>
				}
				subheader={
					props.assessmentItem.dateRejected ? (
						<Typography color="error">{`Gutachten storniert ∙ ${dateCreated}`}</Typography>
					) : (
						<Typography>{`${info} ∙ ${dateCreated}`}</Typography>
					)
				}
			/>
			<CardContent>
				<Thumbnail
					width={300}
					height={400}
					asyncUrl={`/api/storage/${file.hash}/thumbnail`}
					downloadUrl={`/api/storage/${file.hash}`}
					standalone
				/>
			</CardContent>
			<CardActions>
				<Button
					color="primary"
					onClick={handleSelect}
					disabled={!props.onSelect}
				>
					{selectText}
				</Button>
			</CardActions>
		</Card>
	)
};

export default AssessmentItemCard
